import { useMutation } from "react-query"
import customAxios from "../../utils/customAxios"

const axios = customAxios()

interface RequestMobileVerificationPayloadType {
  session_id: string
  phoneNumber: string
}

const fetchRequestMobileVerification = (
  payload: RequestMobileVerificationPayloadType
) => {
  return axios.post(`/users/register/verify_mobile/`, payload)
}

export const useRequestMobileVerification = () => {
  return useMutation(fetchRequestMobileVerification, {
    onSuccess: (data) => {},
    onError: (error) => {},
  })
}
